export const AUTHENTICATION_TOKEN = 'AUTHENTICATION_TOKEN';
export const ORIGIN_LANGUAGE = 'ORIGIN_LANGUAGE';
export const THEME_MODE = 'THEME_MODE';
